import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "mt-4" }

import { dbEnums } from "@/types/enums/dbEnums";
import { DraftStartupperDto } from "@api/draft-startupper-dto";
import { PropType, computed } from "vue";
import { PersonFieldCategoryMap } from "..";
import Field from "../../Field.vue";
import FormFields from "../../FormFields.vue";
import FormSection from "../../FormSection.vue";
import FormSectionHeader from "../../FormSectionHeader.vue";
import { useValidateProps } from "@/composables/fields";


export default /*#__PURE__*/_defineComponent({
  __name: 'StartupperFormAdditionalFields',
  props: {
	fieldsMap: {
		type: Object as PropType<PersonFieldCategoryMap>,
		required: true,
	},
	modelValue: {
		type: Object as PropType<DraftStartupperDto>,
		required: true,
	},
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const fields = dbEnums.PersonFields;
const formDataComputed = computed({
	get() {
		return props.modelValue;
	},
	set(v) {
		emit("update:modelValue", v);
	},
});

const validateProps = useValidateProps();

return (_ctx: any,_cache: any) => {
  const _component_HakoTextArea = _resolveComponent("HakoTextArea")!

  return (_openBlock(), _createBlock(FormSection, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(FormSectionHeader, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("startupperForm.sectionHeaders.additionalInfo")), 1)
            ]),
            _: 1
          })
        ]),
        (__props.fieldsMap.StartupperAdditionalInfo)
          ? (_openBlock(), _createBlock(FormFields, {
              key: 0,
              fields: __props.fieldsMap.StartupperAdditionalInfo.fields
            }, {
              [_unref(fields).StartupperAdditionalInfo]: _withCtx(({ field }) => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(Field, {
                    field: field,
                    propertyPath: "draftStartupperData.additionalInfo"
                  }, {
                    default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                      _createVNode(_component_HakoTextArea, {
                        modelValue: formDataComputed.value.additionalInfo,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formDataComputed.value.additionalInfo) = $event)),
                        id: elementId,
                        isInvalid: isInvalid,
                        onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                      }, null, 8, ["modelValue", "id", "isInvalid", "onBlur"])
                    ]),
                    _: 2
                  }, 1032, ["field"])
                ])
              ]),
              _: 2
            }, 1032, ["fields"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})